import { pipe } from 'pipe-and-compose';

import prop from '../prop';
import defaultTo from '../defaultTo';

const propOr = <T>(defaultValue: T, key: string) => pipe(
  prop(key),
  defaultTo(defaultValue),
);

export default propOr;
